import React, { Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Table,
  Spinner,
  Tooltip,
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import apiResponse from "../../../../services/apiResponse";
import DetailBloc from "./Blocs/DetailBloc";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";
import { generateFormData } from "../../../../helpers/ui/FileInput";

var reformatCriteria = function (datas) {
  return datas.map(function (data) {
    var newObj = {};
    newObj["label"] = data.assessment_criteria_name;
    newObj["tooltip"] = data.assessment_criteria_fullname;
    newObj["value"] = data.assessment_criteria_uuid;
    newObj["model"] = data;
    return newObj;
  });
};

class CreatePenilaianView extends Component {
  userdata = JSON.parse(localStorage.getItem("userdata"));
  is_eselon =
    typeof this.userdata.echelon_code === "string" &&
    (this.userdata.echelon_code.startsWith("1") ||
      this.userdata.echelon_code.startsWith("2"))
      ? 1
      : 0;
  detailBloc = new DetailBloc();

  submitData = async () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const uuid = queryParams.get("uuid");
    let formData = generateFormData();
    formData.append("uuid", uuid);

    this.state.components.forEach((data) => {
      formData.append(data, document.getElementsByName(data)[0].value);
    });
    await this.detailBloc.fetchCreate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  handleChange = (index, val) => {
    this.setState(
      (prevState) => {
        const updatedCriteriaSelected = [...prevState.criteriaSelected];
        updatedCriteriaSelected[index] = val.target.value;
        return {
          criteriaSelected: updatedCriteriaSelected,
        };
      },
      () => {}
    );
  };

  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        // this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  constructor(props) {
    super(props);
    this.state = {
      roleId: localStorage.getItem("currentRoleId"),
      loadingDetail: true,
      loadingTable: false,
      loadingCriteria: false,
      detai: {},
      hukdis: null,
      listCriteria: [],
      listComponents: [],
      criteriaSelected: [],

      // untuk tooltip
      tooltip: false,
      tooltipStyle: {
        marginBottom: 2,
        backgroundColor: "#000",
        color: "#FFF",
        border: "1px solid #000",
      },
    };
  }

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response.result,
              loadingDetail: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.detailBloc.listComponentChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            // data untuk post
            let components = response.result
              .filter((item) => item.assessment_component_type === 2)
              .map((item) => "component_" + item.assessment_component_uuid);

            // data untuk criteria selected
            let initialCriteriaSelected = response.result.map(
              (item) => item.special_allowance_detail_assessment_criteria_uuid
            );

            console.log(initialCriteriaSelected);

            this.setState({
              loading: false,
              dokumen_persyaratan: response.result,
              components: components,
              search_document: 2,
              loadingTable: false,
              listComponents: response.result,
              criteriaSelected: initialCriteriaSelected,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.detailBloc.listCriteriaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingCriteria: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingCriteria: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              listCriteria: reformatCriteria(response.result),
              loadingCriteria: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });
    this.detailBloc.fetchComponent({
      status: 1,
      uuid: queryParams.get("uuid"),
    });
    this.detailBloc.fetchCriteria({ status: 1 });
    // this.detailBloc.createChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       if (result.data.status) {
    //         let response = result.data.response;
    //         this.setState({
    //           success: true,
    //           redirect: true,
    //         });
    //       }
    //       break;
    //     case apiResponse.ERROR:
    //       break;
    //     default:
    //       break;
    //   }
    // });
  }

  componentWillUnmount() {
    this.detailBloc.detailChannel?.unsubscribe();
    this.detailBloc.listComponentChannel?.unsubscribe();
    this.detailBloc.listCriteriaChannel?.unsubscribe();
  }

  render() {
    var number = 0;
    return (
      <Fragment>
        <style>
          {`
            .custom-arrow::before {
              content: "";
              position: absolute;
              width: 0;
              height: 0;
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-right: 6px solid #000; /* Same color as tooltip background */
              top: 50%; /* Position arrow at the vertical center */
              left: -5px; /* Adjust position from the left */
              transform: translateY(-50%); /* Center the arrow vertically */
            }
          `}
        </style>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <CardTitle>
                      {this.state.roleId == "1" ? "Lihat " : "Ubah "} Penilaiain
                    </CardTitle>
                    <CardSubtitle className="mb-3">
                      Informasi Detail Penilaiain
                    </CardSubtitle>
                    <hr />
                    <Row className="mb-3">
                      <label className="col-md-3">Nama </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_full_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_full_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">NIP </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_nip !== ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_nip
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Kategori </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_categories_name_full !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_categories_name_full
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Jabatan </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {/* {this.state.detail
                              .special_allowance_summary_employee_current_position_name
                              ? this.state.detail
                                  .special_allowance_summary_employee_current_position_name
                              : this.state.detail
                                  .special_allowance_summary_employee_current_position_name} */}

                            {this.state.detail
                              .special_allowance_summary_employee_current_position_name ? (
                              <>
                                {
                                  this.state.detail
                                    .special_allowance_summary_employee_current_position_name
                                }
                              </>
                            ) : (
                              <>
                                <span style={{ color: "red" }}>
                                  {
                                    this.state.detail
                                      .special_allowance_summary_skp_position_name
                                  }
                                </span>{" "}
                              </>
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Pangkat </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_current_rank_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_current_rank_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Unit Kerja </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_employee_current_work_unit_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_employee_current_work_unit_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label className="col-md-3">Periode Pembayaran </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_periode_year !== ""
                              ? this.state.detail
                                  .special_allowance_periode_year +
                                " " +
                                this.state.detail
                                  .special_allowance_summary_month_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <hr />

                    <br />
                    <hr />
                    <br />

                    <Table className="table table-striped table-bordered">
                      {this.state.loadingTable === false ? (
                        this.state.listComponents.length > 0 ? (
                          this.state.listComponents.map((data, index) => {
                            if (data.assessment_component_type == 1) {
                              number = 0;
                              return (
                                <thead className="table-primary">
                                  <tr style={{ border: "1px solid #c8cce1" }}>
                                    <th
                                      className="text-center align-middle"
                                      width="5%"
                                    >
                                      No
                                    </th>
                                    <th
                                      className="text-center align-middle"
                                      width="70%"
                                    >
                                      {data.assessment_component_name}
                                    </th>
                                    <th
                                      className="text-center align-middle"
                                      width="25%"
                                    >
                                      Nilai
                                      <br></br>
                                      <i
                                        id="info"
                                        className="fa fa-question-circle fa-lg"
                                      ></i>
                                      <Tooltip
                                        className="text-left"
                                        style={this.state.tooltipStyle}
                                        arrowClassName="custom-arrow"
                                        placement="right"
                                        isOpen={this.state["info"]}
                                        target="info"
                                        toggle={() => {
                                          this.setState({
                                            ["info"]: !this.state["info"],
                                          });
                                        }}
                                      >
                                        {this.state.listComponents.length > 0
                                          ? this.state.listCriteria.map(
                                              (criteria, i) => (
                                                <>
                                                  {criteria.label} :{" "}
                                                  {criteria.tooltip} <br></br>
                                                </>
                                              )
                                            )
                                          : ""}
                                      </Tooltip>
                                    </th>
                                  </tr>
                                </thead>
                              );
                            } else if (data.assessment_component_type == 2) {
                              number = number + 1;
                              return (
                                <tbody>
                                  <tr
                                    key={`tr_tunkin_${index}`}
                                    style={{ border: "1px solid #c8cce1" }}
                                  >
                                    <td className="text-center">{number}</td>
                                    <td className="text-left">
                                      {data.assessment_component_name}
                                    </td>
                                    <td className="text-center">
                                      <Col md="12">
                                        <AvRadioGroup
                                          name={`select-${data.assessment_component_uuid}`}
                                          required
                                          errorMessage="Pilih salah satu"
                                          value={
                                            this.state.criteriaSelected[index]
                                          }
                                          disabled={true}
                                        >
                                          {this.state.loadingTable === false ? (
                                            this.state.listComponents.length >
                                            0 ? (
                                              this.state.listCriteria.map(
                                                (criteria, i) => (
                                                  <div
                                                    key={i}
                                                    className="form-check-inline"
                                                  >
                                                    <AvRadio
                                                      label={criteria.label}
                                                      value={criteria.value}
                                                    />
                                                    {/* <Tooltip
                                                      style={
                                                        this.state.tooltipStyle
                                                      }
                                                      arrowClassName="custom-arrow"
                                                      placement="right"
                                                      isOpen={
                                                        this.state[
                                                          `criteria-${data.assessment_component_uuid}-${criteria.value}`
                                                        ]
                                                      }
                                                      target={`criteria-${data.assessment_component_uuid}-${criteria.value}`}
                                                      toggle={() => {
                                                        this.setState({
                                                          [`criteria-${data.assessment_component_uuid}-${criteria.value}`]:
                                                            !this.state[
                                                              `criteria-${data.assessment_component_uuid}-${criteria.value}`
                                                            ],
                                                        });
                                                      }}
                                                    >
                                                      {criteria.tooltip}
                                                    </Tooltip> */}
                                                  </div>
                                                )
                                              )
                                            ) : (
                                              <tr
                                                style={{
                                                  border: "1px solid #c8cce1",
                                                }}
                                              >
                                                <td
                                                  colSpan="17"
                                                  className="text-center"
                                                >
                                                  Tidak Ada Data
                                                </td>
                                              </tr>
                                            )
                                          ) : (
                                            <tr
                                              style={{
                                                border: "1px solid #c8cce1",
                                              }}
                                            >
                                              <td
                                                colSpan="17"
                                                className="text-center"
                                              >
                                                <Spinner
                                                  className="m-2"
                                                  color="primary"
                                                />
                                              </td>
                                            </tr>
                                          )}
                                        </AvRadioGroup>
                                      </Col>
                                    </td>
                                  </tr>
                                </tbody>
                              );
                            }
                          })
                        ) : (
                          <tr style={{ border: "1px solid #c8cce1" }}>
                            <td colSpan="17" className="text-center">
                              Tidak Ada Data
                            </td>
                          </tr>
                        )
                      ) : (
                        <tr style={{ border: "1px solid #c8cce1" }}>
                          <td
                            colSpan="17"
                            className="text-center"
                            style={{ position: "relative" }}
                          >
                            {/* <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <Spinner className="m-2" color="primary" />
                              Memuat Data...
                            </div> */}
                            <div
                              className="md-12 text-center"
                              style={{
                                alignItems: "center",
                                left: "50%",
                              }}
                            >
                              <Spinner
                                className="text-center"
                                color="primary"
                              />
                              <div>Memuat Data</div>
                            </div>
                          </td>
                        </tr>
                      )}

                      {/* <tbody>
                        {this.state.loadingTable === false ? (
                          this.state.listComponents.length > 0 ? (
                            this.state.listComponents.map((data, index) => {
                              const adjustedIndex = index + 1;

                              return (
                                <tr
                                  key={`tr_tunkin_${index}`}
                                  style={{ border: "1px solid #c8cce1" }}
                                >
                                  <td className="text-center">
                                    {adjustedIndex}
                                  </td>
                                  <td className="text-left">
                                    {data.assessment_component_name}
                                  </td>
                                  <td className="text-left">
                                    <Col md="12">
                                      <AvRadioGroup
                                        name={`select-${data.assessment_component_uuid}`}
                                        required
                                        errorMessage="Pilih salah satu"
                                      >
                                        {this.state.listCriteria.map(
                                          (criteria, i) => (
                                            <div
                                              key={i}
                                              className="form-check-inline"
                                            >
                                              <AvRadio
                                                label={criteria.label}
                                                value={criteria.value}
                                              />
                                            </div>
                                          )
                                        )}
                                      </AvRadioGroup>
                                    </Col>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr style={{ border: "1px solid #c8cce1" }}>
                              <td colSpan="17" className="text-center">
                                Tidak Ada Data
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr style={{ border: "1px solid #c8cce1" }}>
                            <td colSpan="17" className="text-center">
                              <Spinner className="m-2" color="primary" />
                            </td>
                          </tr>
                        )}
                      </tbody> */}
                    </Table>

                    <br />
                    <Row className="mb-3">
                      {/* <Col md="3"></Col> */}
                      <Col md="9">
                        <Link
                          to={`/kepegawaian/verifikasi_tunjangan_khusus.html`}
                        >
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        {this.state.roleId == 2 && this.is_eselon == 1 ? (
                          <>
                            <Button color="success" type="submit">
                              <i className="uil-arrow-up-right"></i> Simpan Data
                            </Button>
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan memproses hukuman disipplin?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={"/kepegawaian/verifikasi_tunjangan_khusus.html"} />
        ) : null}
      </Fragment>
    );
  }
}

export default withRouter(CreatePenilaianView);
